import { render, staticRenderFns } from "./IpcGraph.vue?vue&type=template&id=cc9ecd64&"
import script from "./IpcGraph.vue?vue&type=script&lang=js&"
export * from "./IpcGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\larepublica\\lr-statics\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc9ecd64')) {
      api.createRecord('cc9ecd64', component.options)
    } else {
      api.reload('cc9ecd64', component.options)
    }
    module.hot.accept("./IpcGraph.vue?vue&type=template&id=cc9ecd64&", function () {
      api.rerender('cc9ecd64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lr/js/vue/components/ipc-graph/IpcGraph.vue"
export default component.exports